import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { images } from 'yankees-react-utils';
import { useBlobDownloadQuery } from '../data';

const StyledImg = styled(Image)`
    max-height: 100%;
    width: auto;
    object-fit: cover;
    flex-shrink: 0;
`;

const PlayerHeadshot = ({ playerId, rounded, ...rest }) => {
    const { src } = useBlobDownloadQuery(`/api/player/${playerId}/headshot`);
    return (
        <StyledImg
            src={src}
            rounded={rounded}
            {...rest}
            onError={(event) => {
                event.target.src = images.headshotEmptyImg;
                event.onerror = null;
            }}
        />
    );
};

PlayerHeadshot.defaultProps = {
    rounded: false,
};
PlayerHeadshot.propTypes = {
    playerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    rounded: PropTypes.bool,
};

export default PlayerHeadshot;
